import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/sats-website/sats-website/layouts/default.vue").then(m => m.default || m)),
  page: defineAsyncComponent(() => import("/home/runner/work/sats-website/sats-website/layouts/page.vue").then(m => m.default || m)),
  resource: defineAsyncComponent(() => import("/home/runner/work/sats-website/sats-website/layouts/resource.vue").then(m => m.default || m))
}